import styled from 'styled-components';
import { Spin } from 'antd';
import { useTranslation } from 'react-i18next';

const SpinCentered = ({ text, ...rest }: { text?: string; [x: string]: unknown }) => {
  const { t } = useTranslation();
  return (
    <Container {...rest}>
      <Spin />
      {text !== null && <span className="loading-text">{text ?? t('Loading')}</span>}
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;

  .loading-text {
    color: ${({ theme: { token } }) => token.colorPrimary};
    margin-top: ${({ theme: { token } }) => token.marginXXS}px;
  }
`;

export default SpinCentered;
